import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.19_db0@0.3.2_e_d9ec904c454b7936bcf5ba519cedb11b/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.19__2ca2db9a3b329ee59e005e1cefb27129/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}